import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
// import {
//   ColDef,
//   GridOptions,
//   GridApi,
//   ICellRendererParams,
//   IServerSideGetRowsParams,
//   PaginationChangedEvent, SortChangedEvent
// } from 'ag-grid-community';
// import {IServerSideGetRowsRequest} from 'ag-grid-community/dist/lib/interfaces/iServerSideDatasource';
import {
  ColDef,
  GridApi,
  GridOptions,
  ICellRendererParams,
  IServerSideGetRowsParams,
  IServerSideGetRowsRequest,
  PaginationChangedEvent,
  SortChangedEvent,
  GridReadyEvent
} from 'ag-grid-enterprise';

// importing separate components into ag-grid
import { CheckboxRendererComponent } from './components/checkbox-renderer.component';
import { CreateEditInstructionsViewMode, MutualFundInvestingService } from '../mutual-fund-investing.service';
import { IntegrationService } from '../../shared/services/integration.service';
import { ViewEditRendererComponent } from './components/view-edit-renderer.component';
import {
  CreateEditInstructionsModel,
  OpenInstructionModel
} from '../create-edit-instructions/create-edit-instructions.model';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import moment from 'moment';
import {
  NumberFloatingFilterComponent,
  DateFloatingFilterComponent,
  TextFloatingFilterComponent,
  AccountCellRendererComponent,
  FrequencyFloatingFilterComponent,
  DayToExecuteFilterComponent,
  AccountFilterComponent,
  SymbolFilterComponent,
  AmountTypeFilterComponent,
  InstructionStatusFilterComponent,
  TransactionFilterComponent
} from './components/index';
import { viewInstructionsConstants } from '../../shared/constants/index';
import { IAipInstructionSearchModel } from './view-instructions.model';
import {
  DaysToExecuteValues,
  FilterColumnFields,
  FilterValues,
  FrequencyValues,
  StatusValues
} from '../../shared/constants/filter-constants';
import { AccountRecord } from '../../shared/components/account-search/account-search.model';
import { StorageFactoryService } from '../../shared/storage/storage-factory.service';
import { AccountNumberPipe } from '../../shared/pipes/account-number.pipe';
import { SacAipIntent } from '../../sac-aip.intent';
import { IAipInstructionSearchResponse } from '../mutual-fund-investing.model';
import { tooltipConstants } from '../../shared/constants';
import { NoResultMessageComponent } from '../../shared/components/no-result-message/no-result-message.component';
import { CustomLoadingOverlayComponent } from '../../shared/components/custom-loading-overlay/custom-loading-overlay.component';
import { IJsonApiInstructionSearchAttributes } from '../mutual-fund-investing.model';
import { InformationMessageTooltipComponent } from './components/information-message/information-message-tooltip.component';
import { AccountSearchComponent } from '../../shared/components/account-search/account-search.component';
import { NgClass } from '@angular/common';
import { AgGridAngular } from 'ag-grid-angular';
import { PaginationBarComponent } from './components/pagination-bar/pagination-bar.component';

@Component({
    selector: 'app-view-instructions',
    templateUrl: './view-instructions.component.html',
    styleUrls: ['./view-instructions.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [InformationMessageTooltipComponent, AccountSearchComponent, NgClass, AgGridAngular, PaginationBarComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ViewInstructionsComponent implements OnInit, OnDestroy {
  colDefs: ColDef[];
  public defaultColDef: ColDef;
  public gridOptions: GridOptions;
  public frameworkComponents: any;
  @ViewChild('viewInstructionsGrid')
  viewInstructionsGrid: string;
  refreshInstructions: Subscription;
  results: string;
  private gridApi: GridApi;
  private gridColumnApi;
  private viewInstructionsSub: Subscription;
  filtersApplied: string;
  masterAccountList: Array<AccountRecord> = [];
  private masterAccountListSub: Subscription;
  selectedMasterAccountWithName: string;
  accountNumberPipe = new AccountNumberPipe();
  showPaginationBar: boolean;
  currentPage = 0;
  domLayout = 'normal';
  containerHeight: number;
  mfeContainer: HTMLElement;
  headerTooltipMeassgae: string;
  noResultMessageComponent: string;
  noResultMessageComponentParams: { noRowsMessageFn: (item: string) => string };
  public loadingOverlayComponent: any = CustomLoadingOverlayComponent;
  public loadingOverlayComponentParams: any = {
    loadingMessage: ''
  };
  @Output() gridReadyEvent = new EventEmitter<boolean>();
  exportIcon: string;
  isExportDisabled: boolean;

  constructor(
    private mfInvestingService: MutualFundInvestingService,
    private integrationService: IntegrationService,
    private storageFactoryService: StorageFactoryService,
    private intent: SacAipIntent
  ) {}

  ngOnInit(): void {
    this.refreshInstructions = this.mfInvestingService.refreshMutualFundInstructions$.subscribe(() =>
      this.updateInstructions()
    );
    this.masterAccountListSub = this.mfInvestingService.masterAccountList$.subscribe((list) => this.loadInstructions(list));

    this.gridOptions = {
      context: this,
      suppressContextMenu: true,
      rowHeight: 26,
      floatingFiltersHeight: 40,
      headerHeight: 30,
      rowModelType: 'serverSide',
      serverSideOnlyRefreshFilteredGroups: true,
      serverSideEnableClientSideSort: true,
      onPaginationChanged: this.onPaginationChanged,
      onSortChanged: this.onSortChanged,
      cellSelection: true,
      copyHeadersToClipboard: true,
      animateRows: false,
      theme: 'legacy'
    };
    // Custom-made components used in ag-grid
    this.frameworkComponents = {
      CheckboxRenderer: CheckboxRendererComponent,
      ViewEditRenderer: ViewEditRendererComponent,
      customNumberFloatingFilter: NumberFloatingFilterComponent,
      customDateFilter: DateFloatingFilterComponent,
      customTextFilter: TextFloatingFilterComponent,
      frequencyFloatingFilter: FrequencyFloatingFilterComponent,
      dayToExecuteFloatingFilter: DayToExecuteFilterComponent,
      accountFloatingFilter: AccountFilterComponent,
      symbolFloatingFilter: SymbolFilterComponent,
      transactionFilter: TransactionFilterComponent,
      amountTypeFilter: AmountTypeFilterComponent,
      instructionStatusFilter: InstructionStatusFilterComponent,
      noResultMessageComponent: NoResultMessageComponent,
      spinnerComponent: CustomLoadingOverlayComponent
    };

    this.noResultMessageComponent = 'noResultMessageComponent';
    this.loadingOverlayComponent = 'spinnerComponent';
    // Default options applied to all columns
    this.defaultColDef = {
      sortable: true,
      unSortIcon: true,
      filter: false,
      resizable: false,
      suppressHeaderMenuButton: true,
      suppressMovable: true,
      floatingFilter: true,
      icons: {
        sortAscending: '<i class="sch-caret-up-2x aip-grid-sorting-icon"/>',
        sortDescending: '<i class="sch-caret-down-2x aip-grid-sorting-icon"/>',
        sortUnSort: '<i class="sch-icon sch-caret-down"/>',
        filter: '<span class="ag-header-icon ag-sort-none-icon"></span>'
      }
    };

    // Table attributes
    this.colDefs = [
      {
        field: 'status',
        headerName: 'Status',
        filter: 'agTextColumnFilter',
        floatingFilterComponent: 'instructionStatusFilter',
        width: 100,
        filterParams: {
          buttons: ['apply', 'clear'],
          suppressMiniFilter: true,
          suppressSelectAll: true,
          defaultToNothingSelected: true,
          closeOnApply: true
        },
        floatingFilterComponentParams: {
          suppressFloatingFilterButton: true
        },
        comparator: (valueA, valueB) => {
          const value1 = StatusValues.findIndex((x) => x === valueA);
          const value2 = StatusValues.findIndex((x) => x === valueB);
          return value1 - value2;
        },
        valueGetter: (params): string => {
          if (params.data.status == 'Pending') {
            const formattedValue = params.data.status.toString().replace('Pending', 'Active');
            return formattedValue;
          }
          return params.data.status;
        },
        cellRenderer: this.statusRenderer
      },
      {
        field: 'account',
        headerName: 'Account',
        filter: 'agTextColumnFilter',
        cellRenderer: AccountCellRendererComponent,
        floatingFilterComponent: 'accountFloatingFilter',
        width: 110,
        floatingFilterComponentParams: {
          suppressFloatingFilterButton: true
        },
        comparator: (valueA, valueB) => {
          valueA = valueA.replace('-', '');
          valueB = valueB.replace('-', '');
          return valueA - valueB;
        }
      },
      {
        field: 'accountTitle1',
        headerName: 'Account Registration',
        filter: false,
        width: 250,
        cellStyle: { 'border-right': '1px solid #000000 !important' }
      },
      {
        field: 'transactionType',
        headerName: 'Transaction Type',
        filter: 'agTextColumnFilter',
        floatingFilterComponent: 'transactionFilter',
        width: 126,
        maxWidth: 180,
        filterParams: {
          buttons: ['apply', 'clear'],
          suppressMiniFilter: true,
          suppressSelectAll: true,
          defaultToNothingSelected: true,
          closeOnApply: true
        },
        floatingFilterComponentParams: {
          suppressFloatingFilterButton: true
        }
      },
      {
        field: 'amount',
        headerName: 'Amount',
        filter: 'agNumberColumnFilter',
        type: 'numericColumn',
        floatingFilterComponent: 'customNumberFloatingFilter',
        filterParams: {
          buttons: ['apply', 'clear'],
          filterOptions: ['equals', 'greaterThanOrEqual', 'lessThanOrEqual', 'inRange'],
          suppressMiniFilter: true,
          closeOnApply: true,
          suppressAndOrCondition: true,
          maxNumConditions: 1
        },
        valueGetter: (params): string => {
          if (params.data.amountType === 'Dollars') {
            const formattedValue = params.data.amount
              .toFixed(2)
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            return '$' + formattedValue;
          } else if (params.data.amountType === 'Shares') {
            const formattedValue = params.data.amount.toFixed(3);
            const trailingZeroesRemoved = parseFloat(formattedValue)
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            return trailingZeroesRemoved;
          }
          return params.data.amount;
        },
        width: 120,
        comparator: (valueA, valueB) => {
          valueA = valueA.replace('$', '').replace(',', '');
          valueB = valueB.replace('$', '').replace(',', '');
          return valueA - valueB;
        },
        floatingFilterComponentParams: {
          suppressFloatingFilterButton: true
        }
      },
      {
        field: 'amountType',
        headerName: 'Type',
        filter: 'agTextColumnFilter',
        floatingFilterComponent: 'amountTypeFilter',
        width: 105,
        filterParams: {
          buttons: ['apply', 'clear'],
          suppressMiniFilter: true,
          suppressSelectAll: true,
          defaultToNothingSelected: true,
          closeOnApply: true
        },
        floatingFilterComponentParams: {
          suppressFloatingFilterButton: true
        }
      },
      {
        field: 'symbol',
        headerName: 'Symbol',
        filter: 'agTextColumnFilter',
        floatingFilterComponent: 'symbolFloatingFilter',
        floatingFilterComponentParams: {
          suppressFloatingFilterButton: true
        },
        width: 90
      },
      {
        field: 'frequency',
        headerName: 'Frequency',
        filter: 'agTextColumnFilter',
        floatingFilterComponent: 'frequencyFloatingFilter',
        cellClass: 'frequency-col',
        width: 133,
        comparator: (valueA, valueB) => {
          const day1 = FrequencyValues.findIndex((x) => x === valueA);
          const day2 = FrequencyValues.findIndex((x) => x === valueB);
          return day1 - day2;
        },
        floatingFilterComponentParams: {
          suppressFloatingFilterButton: true
        }
      },
      {
        field: 'dayToExecute',
        headerName: 'Day to Execute',
        filter: 'agTextColumnFilter',
        floatingFilterComponent: 'dayToExecuteFloatingFilter',
        floatingFilterComponentParams: {
          suppressFloatingFilterButton: true
        },
        width: 117,
        comparator: (valueA, valueB) => {
          const day1 = DaysToExecuteValues.findIndex((x) => x === valueA.split(',', 1).toString());
          const day2 = DaysToExecuteValues.findIndex((x) => x === valueB.split(',', 1).toString());
          return day1 - day2;
        },
        valueGetter: (params): string => {
          if (params.data.dayToExecute2 && params.data.frequency === 'Twice a month') {
            return params.data.dayToExecute + ', ' + params.data.dayToExecute2;
          } else {
            return params.data.dayToExecute;
          }
        }
      },
      {
        field: 'next',
        comparator: function dateComparator(date1, date2): number {
          const date1Number = date1 && new Date(date1).getTime();
          const date2Number = date2 && new Date(date2).getTime();
          if ((date1Number === null || date1 === '') && (date2Number === null || date2 === '')) {
            return 0;
          }

          if (date1Number === null || date1 === '') {
            return 1;
          } else if (date2Number === null || date2 === '') {
            return -1;
          }

          return date1Number - date2Number;
        },
        headerName: 'Next',
        filter: 'agDateColumnFilter',
        floatingFilterComponent: 'customDateFilter',
        floatingFilterComponentParams: {
          suppressFloatingFilterButton: true
        },
        filterParams: {
          filterOptions: ['equals', 'greaterThanOrEqual', 'lessThanOrEqual', 'inRange'],
          buttons: ['apply', 'clear'],
          inRangeInclusive: true,
          suppressAndOrCondition: true,
          closeOnApply: true,
          maxNumConditions: 1
        },
        width: 90
      },
      {
        field: 'endDate',
        comparator: (date1: string, date2: string): number => {
          if ((date1 == null || date1 === '') && (date2 == null || date2 === '')) {
            return 0;
          }

          if (date1 == null || date1 === '') {
            return -1;
          } else if (date2 == null || date2 === '') {
            return 1;
          }

          if (moment(moment(date1, 'MM/DD/YYYY')).isBefore(moment(date2, 'MM/DD/YYYY'), 'day')) {
            return -1;
          } else if (moment(moment(date2, 'MM/DD/YYYY')).isBefore(moment(date1, 'MM/DD/YYYY'), 'day')) {
            return 1;
          }
        },
        headerName: 'Stop',
        filter: 'agDateColumnFilter',
        floatingFilterComponent: 'customDateFilter',
        floatingFilterComponentParams: {
          suppressFloatingFilterButton: true
        },
        filterParams: {
          filterOptions: ['equals', 'greaterThanOrEqual', 'lessThanOrEqual', 'inRange'],
          buttons: ['apply', 'clear'],
          inRangeInclusive: true,
          suppressAndOrCondition: true,
          closeOnApply: true,
          maxNumConditions: 1
        },
        valueGetter: (params) => {
          //check if restart date is populated
          if (params.data.restartDate) {
            //check if end date is before restart date
            if (
              moment(moment(params.data.endDate, 'MM/DD/YYYY')).isBefore(
                moment(params.data.restartDate, 'MM/DD/YYYY'),
                'day'
              )
            ) {
              return '';
            } else {
              return params.data.endDate;
            }
          } else {
            return params.data.endDate;
          }
        },
        width: 90
      },
      {
        headerName: 'View/Edit',
        floatingFilter: false,
        sortable: false,
        width: 80,
        pinned: 'right',
        cellRenderer: 'ViewEditRenderer',
        headerClass: 'view-edit',
        cellStyle: {
          textAlign: 'center'
        }
      }
    ];
    const state = this.storageFactoryService.getAipSessionState();
    const sessionId = this.integrationService.getSessionId();
    if (state) {
      if (!state.id || state.id !== sessionId) {
        this.storageFactoryService.clearAipSessionState();
      }
    } else {
      this.storageFactoryService.setAipSessionState({ id: sessionId });
    }
    this.mfeContainer = document.getElementById('spa-mutual-fund-investing');
    if (this.mfeContainer) {
      this.containerHeight = document.getElementById('spa-mutual-fund-investing').offsetHeight;
    }
    this.headerTooltipMeassgae = tooltipConstants.infoMessage;
    this.exportIcon = this.integrationService.getApplicationPath() + 'assets/images/Download_Disabled.svg';
  }

  ngOnDestroy(): void {
    this.refreshInstructions.unsubscribe();
    this.masterAccountListSub.unsubscribe();
    //if (this.componentStateSub$) this.componentStateSub$.unsubscribe();
  }

  onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.gridApi?.sizeColumnsToFit();
    if (this.mfeContainer) {
      this.mfeContainer.classList.add('mutual-fund-investing');
    }
    this.setGridToDefault();
    this.setFilterPlaceHolderText();
    this.removeFilterHeaderTabIndex();
    this.gridReady(true);
  }

  gridReady(value: boolean): void {
    this.gridReadyEvent.emit(value);
  }

  private onPaginationChanged = (event: PaginationChangedEvent) => {
    this.currentPage = event.api.paginationGetCurrentPage();
  };

  private onSortChanged = (event: SortChangedEvent) => {
    this.gridApi.paginationGoToPage(0);
  };

  getViewInstructions(masterAccount?: string[]): void {
    this.gridApi.setGridOption('serverSideDatasource', {
      getRows: (params: IServerSideGetRowsParams) => {
        const request: IAipInstructionSearchModel = this.getSearchInstructionRequest(params.request);
        request.masterAccountIdList = masterAccount ? masterAccount : this.getInstructionsForAllMasters();
        this.showPaginationBar = false;
        this.viewInstructionsSub = this.mfInvestingService
          .getMutualFundInstructions(request)
          .pipe(
            tap((response: IAipInstructionSearchResponse) =>
              response.data.length <= 0 ? this.gridApi?.showNoRowsOverlay() : this.gridApi.setGridOption('loading', true)
            ),
            tap((response) => {
              if (response.data.length > 0) {
                this.gridApi?.setGridOption('loading', false);
                this.gridApi.paginationGoToPage(0);
                this.gridApi.setGridOption('domLayout', 'autoHeight');
                this.adjustContainerHeight(false);
                response.data.length <= 50 ? (this.showPaginationBar = false) : (this.showPaginationBar = true);
                this.isExportDisabled = false;
                this.exportIcon = this.integrationService.getApplicationPath() + 'assets/images/Download.svg';
              } else {
                this.gridApi?.setGridOption('loading', false);
                this.showPaginationBar = false;
                this.gridApi.setGridOption('domLayout', 'normal');
                this.gridApi?.showNoRowsOverlay();
                this.adjustContainerHeight(true);
                this.isExportDisabled = true;
                this.exportIcon = this.integrationService.getApplicationPath() + 'assets/images/Download_Disabled.svg';
              }
            }),
            tap((response) => (this.results = response.data.length > 0 ? response.data.length + ' result(s)' : null))
          )
          .subscribe(
            (response) =>
              params.success({
                rowData: response.data.map((r) => {
                  return this.mapViewInstructionsResponse(r.attributes);
                }),
                rowCount: response.data.length
              }),
            (_error) => {
              this.gridApi?.setGridOption('loading', false);
              params.fail();
              this.gridApi?.showNoRowsOverlay();
              this.isExportDisabled = true;
              this.exportIcon = this.integrationService.getApplicationPath() + 'assets/images/Download_Disabled.svg';
            }
          );
      },
      destroy: () => this.viewInstructionsSub?.unsubscribe()
    });
  }

  mapViewInstructionsResponse(response: IJsonApiInstructionSearchAttributes): IJsonApiInstructionSearchAttributes {
    if (response.next === viewInstructionsConstants.instructionMinDate) {
      response.next = '';
    }

    //if restart date AND end date are populated AND both are in the past THEN end date is set to a blank string
    if (response.endDate != null && response.restartDate != null) {
      let endDateTime = new Date(response.endDate);
      let restartDateTime = new Date(response.restartDate);
      let todayDateTime = new Date();

      if (endDateTime <= todayDateTime && restartDateTime <= todayDateTime) {
        response.endDate = '';
      }
    }

    return response;
  }

  // Custom component for status and status icons
  statusRenderer = (params: ICellRendererParams): string => {
    let iconClass = '';
    switch (params.value) {
      case 'Active':
        iconClass = '<i class="sch-check-circle sdps-text-gain status-icon"></i>';
        break;
      case 'Restarted':
        iconClass = '<i class="sch-check-circle sdps-text-gain status-icon"></i>';
        break;
      case 'Pending':
        params.value = 'Active';
        iconClass = '<i class="sch-check-circle sdps-text-gain status-icon"></i>';
        break;
      case 'Stopped':
        const assetUrl = this.integrationService.getApplicationPath();
        iconClass = '<img class="status-icon" src="' + assetUrl + 'assets/images/Expand-Circle-Filled-Closed.svg"/>';
        break;
    }

    return '<span id="status">' + iconClass + '<p>' + params.value + '</p>' + '</span>';
  };

  createNew(): void {
    this.mfInvestingService.openCreateEditInstructions();
  }

  openViewEditInstruction(instruction: CreateEditInstructionsModel): void {
    instruction.accountName = instruction.accountTitle1;
    instruction.accountDescription = (instruction.accountTitle2 ?? '') + (instruction.accountTitle3 ?? '');
    const openModel: OpenInstructionModel = {
      instruction: instruction,
      mode: CreateEditInstructionsViewMode.VIEW_INSTRUCTION
    };
    this.mfInvestingService.openCreateEditInstructions(openModel);
  }

  private setDefaultFilter() {
    const toDate = moment().add(30, 'days').format('YYYY-MM-DD');
    const fromDate = moment().format('YYYY-MM-DD');
    const filter = {
      next: {
        dateFrom: fromDate,
        dateTo: toDate,
        type: 'inRange',
        filterType: 'date'
      }
    };
    return filter;
  }

  private setFilterPlaceHolderText(): void {
    Array.from(document.getElementsByClassName('ag-text-field-input')).forEach((obj) => {
      if (!obj.classList.contains('client-search')) {
        obj.setAttribute('placeholder', 'Filter');
      }
    });
  }
  // added to prevent focusout on Escape or Tab key
  private removeFilterHeaderTabIndex(): void {
    Array.from(document.getElementsByClassName('ag-header-cell')).forEach((obj) => {
      if (obj.classList.contains('ag-focus-managed')) {
        obj.removeAttribute('tabindex');
      }
    });
  }

  async onFilterChanged(): Promise<void> {
    this.updateSpinner();
    const next = await this.gridApi.getColumnFilterInstance('next');
    const model = next.getModel();
    if (model && model.type !== 'inRange' && model.dateTo) {
      model.dateTo = null;
      next.setModel(model);
    }
    const endDateInstance = await this.gridApi.getColumnFilterInstance('endDate');
    const endDatemodel = endDateInstance.getModel();
    if (endDatemodel && endDatemodel.type !== 'inRange' && endDatemodel.dateTo) {
      endDatemodel.dateTo = null;
      endDatemodel.setModel(model);
    }
  }

  resetToDefault(event): void {
    event.preventDefault();
    this.setGridToDefault();
  }

  resetFilter(event): void {
    event.preventDefault();
    this.updateSpinner();
    this.gridApi.setFilterModel(null);
    this.gridApi.applyColumnState({
      defaultState: { sort: null }
    });
  }

  private setGridToDefault(): void {
    const filter = this.setDefaultFilter();
    this.gridApi.setFilterModel(filter);
    this.gridApi.applyColumnState({
      state: [{ colId: 'next', sort: 'asc' }],
      defaultState: { sort: null }
    });
    this.updateSpinner();
    this.getViewInstructions();
  }

  getSearchInstructionRequest(request: IServerSideGetRowsRequest): IAipInstructionSearchModel {
    let requestModal: IAipInstructionSearchModel = {};
    const filterKeys = Object.keys(request.filterModel);
    this.filtersApplied = filterKeys.length > 0 ? filterKeys.length + ' filter(s) applied' : null;
    if (filterKeys && filterKeys.length > 0) {
      filterKeys.forEach((filterKey) => {
        switch (filterKey) {
          case FilterColumnFields.status:
            requestModal.statusCode = request.filterModel[filterKey].filter;
            break;
          case FilterColumnFields.account:
            requestModal.accountId = request.filterModel[filterKey].filter.replace('-', '');
            break;
          case FilterColumnFields.transactionType:
            requestModal.transactionType = request.filterModel[filterKey].filter;
            break;
          case FilterColumnFields.amountType:
            requestModal.amountType = request.filterModel[filterKey].filter;
            break;
          case FilterColumnFields.symbol:
            requestModal.symbol = request.filterModel[filterKey].filter;
            break;
          case FilterColumnFields.frequency:
            requestModal.frequency = request.filterModel[filterKey].filter;
            break;
          case FilterColumnFields.next:
            const startDateObj = request.filterModel[filterKey];
            requestModal = this.setDateFields(requestModal, startDateObj, FilterColumnFields.next);
            break;
          case FilterColumnFields.endDate:
            const endDateObj = request.filterModel[filterKey];
            requestModal = this.setDateFields(requestModal, endDateObj, FilterColumnFields.endDate);
            break;
          case FilterColumnFields.amount:
            const amountFilter = request.filterModel[filterKey];
            requestModal = this.setAmountFields(requestModal, amountFilter);
            break;
          case FilterColumnFields.dayToExecute:
            const dayToExecuteFilter = request.filterModel[filterKey];
            requestModal = this.setDayToExecute(requestModal, dayToExecuteFilter);
            break;
        }
      });
    }
    return requestModal;
  }

  private setDateFields(
    request: IAipInstructionSearchModel,
    filterObj: any,
    filterType: string
  ): IAipInstructionSearchModel {
    const formattedDateFrom = this.formatDate(filterObj.dateFrom);
    const formattedDateTo = filterObj.dateTo ? this.formatDate(filterObj.dateTo) : null;
    switch (filterObj.type) {
      case FilterValues.equals:
        if (filterType === FilterColumnFields.next) {
          request.nextDateFrom = formattedDateFrom;
          request.nextDateTo = formattedDateFrom;
        } else {
          request.stopDateFrom = formattedDateFrom;
          request.stopDateTo = formattedDateFrom;
        }
        break;
      case FilterValues.greaterThanOrEqual:
        filterType === FilterColumnFields.next
          ? (request.nextDateFrom = formattedDateFrom)
          : (request.stopDateFrom = formattedDateFrom);
        break;
      case FilterValues.lessThanOrEqual:
        filterType === FilterColumnFields.next
          ? (request.nextDateTo = formattedDateFrom)
          : (request.stopDateTo = formattedDateFrom);
        break;
      case FilterValues.inRange:
        if (filterType === FilterColumnFields.next) {
          request.nextDateFrom = formattedDateFrom;
          request.nextDateTo = formattedDateTo;
        } else {
          request.stopDateFrom = formattedDateFrom;
          request.stopDateTo = formattedDateTo;
        }
        break;
    }
    return request;
  }

  private setAmountFields(request: IAipInstructionSearchModel, filterObj: any): IAipInstructionSearchModel {
    switch (filterObj.type) {
      case FilterValues.equals:
        request.amountFrom = filterObj.filter;
        request.amountTo = filterObj.filter;
        break;
      case FilterValues.greaterThanOrEqual:
        request.amountFrom = filterObj.filter;
        break;
      case FilterValues.lessThanOrEqual:
        request.amountTo = filterObj.filter;
        break;
      case FilterValues.inRange:
        request.amountFrom = filterObj.filter;
        request.amountTo = filterObj.filterTo;
        break;
    }
    return request;
  }

  private setDayToExecute(request: IAipInstructionSearchModel, filterObj: any): IAipInstructionSearchModel {
    const value = filterObj.filter;
    if (value.toString().indexOf('-') > -1) {
      const range = value.split('-');
      request.dayToExecuteFrom = Number(range[0]);
      request.dayToExecuteTo = Number(range[1]);
    } else {
      request.dayToExecute = value;
    }
    return request;
  }

  private formatDate(date: string): string {
    return moment(date).format('MM/DD/YYYY');
  }

  public masterAccountSelected(account: AccountRecord): void {
    this.getViewInstructions([account.accountId]);
    const state = this.storageFactoryService.getAipSessionState();
    if (state) {
      state.masterAccount = account.accountId;
      this.storageFactoryService.setAipSessionState(state);
    } else {
      this.storageFactoryService.setAipSessionState({
        masterAccount: account.accountId,
        id: this.integrationService.getSessionId()
      });
    }
  }

  public getInstructionsForAllMasters(isClear?: boolean): string[] {
    const state = this.storageFactoryService.getAipSessionState();
    let masterAccounts: string[];
    if (this.masterAccountList) {
      masterAccounts = this.getMasterAccountFromStorage(isClear);
    }
    if (!isClear) {
      return masterAccounts;
    }
    this.getViewInstructions(masterAccounts);
    this.removeMasterAccountFromStorage();
  }

  private loadInstructions(list: Array<AccountRecord>): void {
    this.masterAccountList = list;
    this.intent.hideLoadingIcon();
  }

  private updateInstructions(): void {
    const masterAccountIds = this.getMasterAccountFromStorage();
    this.getViewInstructions(masterAccountIds);
  }

  private getMasterAccountFromStorage(isClear?: boolean): string[] {
    const state = this.storageFactoryService.getAipSessionState();
    const masterAccountIds: string[] = [];
    if (state && state.masterAccount && !isClear) {
      const account: AccountRecord = this.masterAccountList.find((item) => state.masterAccount === item.accountId);
      const transformedAccountNumber = this.accountNumberPipe.transform(account.accountId);
      this.selectedMasterAccountWithName = transformedAccountNumber + ' ' + account.accountName;
      masterAccountIds.push(account.accountId);
    } else {
      this.masterAccountList.forEach((account: AccountRecord) => {
        masterAccountIds.push(account.accountId);
      });
    }
    return masterAccountIds;
  }

  private removeMasterAccountFromStorage(): void {
    const state = this.storageFactoryService.getAipSessionState();
    if (state && state.masterAccount) {
      state.masterAccount = null;
      this.storageFactoryService.setAipSessionState(state);
    }
  }

  updateSpinner(): void {
    setTimeout(() => {
      this.gridApi.setGridOption('loading', true);
    }, 100);
  }

  private adjustContainerHeight(isNoResults): void {
    const instructionsContainer = document.getElementById('table-content');
    if (isNoResults) {
      this.mfeContainer.classList.add('mutual-fund-investing');
      instructionsContainer.classList.remove('container-auto-height');
    } else {
      this.mfeContainer.style.height = 'unset';
      this.mfeContainer.style.minHeight = this.containerHeight + 'px';
      this.mfeContainer.classList.remove('mutual-fund-investing');
      instructionsContainer.classList.add('container-auto-height');
    }
  }

  exportButtonClick(): void {
    const params = {
      columnKeys: [
        'status',
        'account',
        'transactionType',
        'amount',
        'amountType',
        'symbol',
        'frequency',
        'dayToExecute',
        'next',
        'endDate'
      ],
      fileName: `AutomaticMFInvestingExport_${moment().format('MMDDYYYYHHmmss')}`,
      processCellCallback: (params) => this.formatAccountNumberForExport(params)
    };
    this.gridApi.exportDataAsCsv(params);
  }

  private formatAccountNumberForExport(params) {
    let cellValue = params.value;

    if (params?.column?.colDef?.headerName === 'Account') {
      cellValue = cellValue.replace(/(\d{4})/, '$1-');
    }
    return cellValue;
  }
}
